import React from 'react';
import {MasterLayout} from 'components/layouts';
import {MyBusiness} from 'components/my-business';
import BusinessZone from 'pages/my-business/BusinessZone.jsx';
import title from 'constants/TitlePages.js';

class MyBusinessPage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.MyBusinessPage;
  }

  render() {
    return (
      <MasterLayout isActive='my-business-news'>
        <MyBusiness params={this.props.match.params}/>
      </MasterLayout>
    );
  }
}

export default BusinessZone(MyBusinessPage);



// WEBPACK FOOTER //
// ./pages/my-business/MyBusinessPage.jsx